var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"1","y1":"1","x2":"13","y2":"13","key":0}),React.createElement("line",{"x1":"13","y1":"1","x2":"1","y2":"13","key":1})]);
}

Close.defaultProps = {"viewBox":"0 0 14 14","fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round"};

module.exports = Close;

Close.default = Close;
